import { DATE_FORMAT } from "../utils/config";
import DateFns from "date-fns";


export  const isDateFormat=(fromdata,todata)=> {
  return `${DateFns.format(fromdata,"DD/MM/YYYY")}-${DateFns.format(todata,"DD/MM/YYYY")} `
  }


 export  const isSingleDateFormat=(data)=> {
    let date = new Date(data);

    let year = date.getFullYear();
    let day = date.getDate();
    let month = date.getMonth() ;

    if (`${day}`.length === 1) day = `0${day}`;
    if (`${month}`.length === 1) month = `0${month}`;
    if (DATE_FORMAT === "DD-MM-YYYY") return `${day}-${month}-${year}`;

    return `${month}-${day}-${year}`;

    // return data.getYear();
    // if (data === undefined) return;
  }

